import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PageCTA from "@/components/PageCTA";
import { HERO_BLOG } from "@/components/heroBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog`).then(res => {
      setPosts(res.data);
      setLoading(false);
    });
  }, []);

  const formatDate = (d) =>
    new Date(d).toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div className="min-h-screen" data-testid="blog-page">
      <div className="subpage-hero subpage-hero--bg flex items-end" style={HERO_BLOG}>
        <div className="container pb-0">
          <p className="eyebrow mb-4">Blog</p>
          <h1 className="font-heading text-[clamp(36px,5vw,56px)] text-[var(--color-text-light)] mb-4">
            Wiedza, która pomaga rozwijać markę
          </h1>
          <p className="lead max-w-xl">Praktyczne porady o stronach WWW, grafice, widoczności w Google i promocji biznesu.</p>
        </div>
      </div>

      <div className="section bg-[var(--color-cream)]">
        <div className="container">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {loading
              ? [...Array(6)].map((_, i) => (
                  <div key={i} className="bg-[var(--color-white)] rounded h-80 animate-pulse border border-[var(--color-border-light)]" />
                ))
              : posts.map((post, idx) => (
                  <motion.article
                    key={post.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.05 }}
                    data-testid={`blog-post-${idx}`}
                  >
                    <Link to={`/blog/${post.slug}`} className="group">
                      <div className="product-card">
                        <div className="aspect-[3/2] bg-[var(--color-cream)] overflow-hidden">
                          <img
                            src={post.image_url}
                            alt={post.title}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          />
                        </div>
                        <div className="p-5">
                          <div className="flex items-center gap-3 mb-3">
                            <span className="text-[11px] font-body font-semibold text-[var(--color-gold)] uppercase tracking-wider">
                              {post.category}
                            </span>
                            <span className="text-[11px] font-body text-[var(--color-text-muted)]">
                              {formatDate(post.created_at)}
                            </span>
                          </div>
                          <h2 className="font-heading text-xl font-medium text-[var(--color-text-dark)] group-hover:text-[var(--color-gold)] transition-colors leading-snug line-clamp-2">
                            {post.title}
                          </h2>
                          <p className="text-xs font-body text-[var(--color-text-muted)] mt-2 line-clamp-2">{post.excerpt}</p>
                          <span className="inline-flex items-center gap-1 text-xs font-body font-semibold uppercase tracking-wider text-[var(--color-gold)] mt-4">
                            Czytaj dalej <ArrowRight className="w-3 h-3" />
                          </span>
                        </div>
                      </div>
                    </Link>
                  </motion.article>
                ))}
          </div>
        </div>
      </div>
      <PageCTA />
    </div>
  );
};

export default Blog;
